import React from "react";
import { Link, withRouter } from "react-router-dom";
import {Panel,PanelHeader, PanelBody,} from "../../components/panel/panel.jsx";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import ReactTags from "react-tag-autocomplete";
//import DatePicker from "react-datepicker";
import TextField from '@mui/material/TextField';
import DateTime from "react-datetime";
import moment from "moment";
//import Select from 'react-select';
//import Select from "../../common/select";
import Tooltip from "rc-tooltip";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import Joi, { date } from "joi";
import Form from "../../common/form.jsx";
import { apiUrl } from "../../config/config.json";
import http from "../../services/httpService";
import { saveWasteType, getWasteType } from "./../../services/wastetypes";
import { getWasteTypes } from "./../../services/wastetypes";
import Select from 'react-select'
import auth from "../../services/authservice";

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Handle = Slider.Handle;

class WasteType extends Form {
  constructor(props) {
    super(props);

    const user = auth.getProfile();
    var maxYesterday = "";
    var minYesterday = DateTime.moment().subtract(1, "day");

    this.minDateRange = (current) => {
      return current.isAfter(minYesterday);
    };
    this.maxDateRange = (current) => {
      return current.isAfter(maxYesterday);
    };
    this.minDateChange = (value) => {
      this.setState({
        maxDateDisabled: false,
      });
      maxYesterday = value;
    };

    this.state = {
      maxDateDisabled: true,
      wastetypes:[],
      data: {
	    name: "",
	    color: "#000000",	
      user : user._id
      },
      errors: {},
    };

    this.handleSlider = (props) => {
      const { value, dragging, index, ...restProps } = props;
      return (
        <Tooltip
          prefixCls="rc-slider-tooltip"
          overlay={value}
          visible={dragging}
          placement="top"
          key={index}
        >
          <Handle value={value} {...restProps} />
        </Tooltip>
      );
    };

    this.handleSelectChange = ( { _id } , field ) => {
      console.log("SELECT ONCHANGE : " , _id)
      this.setState({ data: {...this.state.data , [field] : _id }})
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
    
  schema = Joi.object({
	name: Joi.string().optional(),
    color: Joi.any().optional(),
  });

  handleDateChange = (e) => {
    const errors = { ...this.state.errors };
    const data = { ...this.state.data };
	  data["date"] = new Date(e);
    this.setState({ data });
    console.log(this.state.data);
  };
  

  doSubmit = async (wastetype) => {
    
    try
    {
	    const data = { ...this.state.data };

      this.setState({ data });
      await saveWasteType( data );
      this.props.history.push("/kaizen/wastetypes");

    }
    catch (ex)
    {
      console.error(ex)
      if (ex.response) {
        const errors = { ...this.state.errors };
        errors.status = ex.response.data;
        this.setState({ errors });
        console.log(this.state.errors);
      }
    }
  };

  async populateWasteType ()
  {
    const ID = this.props.match.params.id
    if ( ID === "new" )
    return

    let { data : wasteType } = await getWasteType(ID)
    console.log( "populating waste type : " ,  wasteType )
    this.setState({ data : this.mapToViewModel(wasteType) })

    console.log( "after mapping : " , this.state.data)

  }

  async componentDidMount()
  {
    await this.populateWasteType()
  }

  mapToViewModel(WasteType) {
    return {
      user : WasteType.user._id , 
      _id: WasteType._id,
	    name: WasteType.name,		
      color: WasteType.color,
    };
  }

  render() {
    const { data, errors } = this.state;
    console.log("wastetype data : " , data)
    return (
      <React.Fragment>
        <div>
          <ol className="breadcrumb float-xl-right">
            <li className="breadcrumb-item">
              <Link to="/wastetypess">WasteTypes</Link>
            </li>
            <li className="breadcrumb-item active">Add/Edit WasteType</li>
          </ol>
          <h1 className="page-header">
            Add WasteType <small>WasteType-registration-form</small>
          </h1>

          <div className="row">
            <div className="col-xl-10">
              <Panel>
                <PanelHeader>Add/Edit WasteType</PanelHeader>
                <PanelBody className="panel-form">
                  <form className="form-horizontal form-bordered" onSubmit={this.handleSubmit}>
							    {this.renderInput("name", "Name", "name", "Enter name of waste-type")}									  
							    {this.renderInput("color", "Color", "color", "Enter color")}					

                    <div className="form-group row">
                      <div className="col-lg-4">
                        <button type="submit" disabled={this.validate} className="btn btn-primary btn-block btn-lg" >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </PanelBody>
              </Panel>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(WasteType);